
import en from '../locales/en-US.json';
import de from '../locales/de-DE.json';
import type { I18n } from 'vue-i18n';


export const translations: Record<string, Record<string, any>> = {
  'en-US': en,
  'de-DE': de,
};

/**
 * Merges all available translations from the library into the given i18n instance.
 * @param {I18n} i18n - The Vue i18n instance
 */
export function mergeLibraryTranslations(i18n: I18n): void {
  if (!i18n || !i18n.global) {
    console.warn('Invalid i18n instance provided.');
    return;
  }

  Object.keys(translations).forEach((locale) => {
    if (i18n.global.availableLocales.includes(locale)) {
      i18n.global.mergeLocaleMessage(locale, translations[locale]);
    }
  });
}
